import { TOP_UP_TRIP_STATUSES } from '@chukua/common';

/** Offer a top-up on exactly the trips the server accepts one for: out on the road, not yet delivered. */
export function isTopUpStatus(status: string): boolean {
  return (TOP_UP_TRIP_STATUSES as readonly string[]).includes(status);
}
